var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Layout } from "@consta/uikit/Layout";
import { Button } from "@consta/uikit/Button";
import { DragNDropField, DragNDropFieldInformer, getErrorsList, } from "@consta/uikit/DragNDropFieldCanary";
import { Select } from "@consta/uikit/Select";
import { Text } from "@consta/uikit/Text";
import { TextField } from "@consta/uikit/TextField";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useAuthManagerStore } from "../../../../../core/services/stores/authManagerStore/store";
import { parseFullUserName } from "../../../../utils/system/parceFullName";
import styles from "./Feedback.module.scss";
import { REASONS_LIST } from "./utils/reasons-list";
import { STOCK_FEEDBACK } from "./utils/stock-feedback";
import { IconAlert } from "@consta/icons/IconAlert";
import { IconAttach } from "@consta/icons/IconAttach";
import { IconDocFilled } from "@consta/icons/IconDocFilled";
import { IconRevert } from "@consta/icons/IconRevert";
import { IconTrash } from "@consta/icons/IconTrash";
import { Attachment } from "@consta/uikit/Attachment";
import { presetGpnDark } from "@consta/uikit/Theme";
import cn from "classnames";
import { useSendFeedback } from "../../../../../core/services/api/feedback-api/feedback-tanstack";
import { useThemeStore } from "../../../../../core/services/stores/themeStore/store";
import { environment } from "../../../../../environment";
import { DEFAULT_FILE_SIZE } from "../../../../const/files";
import { ConstaDragAndDropStatus } from "../../../../enums/consta-statuses";
import { FeedbackFields } from "../../../../enums/feedback-fields";
import { ACCEPT_FILES } from "./utils/accept-files";
var DEFAULT_FIELD_ROWS = 5;
var Feedback = function (_a) {
    var setUserModal = _a.setUserModal;
    var methods = useForm({
        defaultValues: STOCK_FEEDBACK,
    });
    var userName = useAuthManagerStore(function (state) { return state.userName; });
    var theme = useThemeStore(function (state) { return state.selectedTheme; });
    var sendFeedback = useSendFeedback();
    var control = methods.control, getValues = methods.getValues, setValue = methods.setValue, watch = methods.watch;
    var _b = useState([]), filesDropped = _b[0], setFilesDropped = _b[1];
    var _c = useState([]), fileRejections = _c[0], setFileRejections = _c[1];
    var _d = useState(), otherError = _d[0], setOtherError = _d[1];
    var _e = useState(ConstaDragAndDropStatus.DEFAULT), status = _e[0], setStatus = _e[1];
    var _f = useState(), informerText = _f[0], setInformerText = _f[1];
    var handleDrop = function (acceptedFiles, rejections) {
        setFilesDropped(acceptedFiles);
        setFileRejections(rejections);
    };
    function onSubmit() {
        sendFeedback.mutate(getFormData());
        setUserModal(false);
    }
    function getFormData() {
        var formData = new FormData();
        if (filesDropped.length) {
            for (var _i = 0, filesDropped_1 = filesDropped; _i < filesDropped_1.length; _i++) {
                var file = filesDropped_1[_i];
                if (file instanceof Blob) {
                    formData.append(FeedbackFields.FILES, file, file.name);
                }
            }
        }
        formData.append(FeedbackFields.CONTENT, getValues(FeedbackFields.CONTENT) +
            "\n[\u0412\u0435\u0440\u0441\u0438\u044F \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430: ".concat(environment.curVersion, "]"));
        formData.append(FeedbackFields.STATUS, getValues(FeedbackFields.STATUS).label);
        return formData;
    }
    function getFileInfo(file) {
        var _a;
        var extension = file.name.split(".");
        if (extension && extension.at(-1)) {
            return {
                name: file.name,
                extension: (_a = extension.at(-1)) !== null && _a !== void 0 ? _a : "",
            };
        }
        else {
            return {
                name: "",
                extension: "",
            };
        }
    }
    function genFileView(file) {
        var fileInfo = getFileInfo(file);
        return (_jsx(Attachment, { fileName: fileInfo.name, fileExtension: fileInfo.extension, buttonIcon: IconTrash, buttonTitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", withPictogram: true, onButtonClick: function (e) {
                e.stopPropagation();
                setFilesDropped(filesDropped.filter(function (curFile) { return curFile.name !== file.name; }));
            } }));
    }
    var getDragAndDropContent = function () { return (_jsxs(_Fragment, { children: [Boolean(!filesDropped.length) && (_jsxs(_Fragment, { children: [_jsx(Text, __assign({ className: styles.informText }, { children: "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0441\u044E\u0434\u0430 \u0444\u0430\u0439\u043B\u044B \u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438" })), _jsx(IconAttach, { className: cn({
                            lightColorTypo: theme === presetGpnDark,
                        }) })] })), Boolean(filesDropped.length) && (_jsx(Layout, __assign({ direction: "column", className: styles.filesContainer }, { children: filesDropped.map(function (item) { return genFileView(item); }) })))] })); };
    useEffect(function () {
        switch (status) {
            case ConstaDragAndDropStatus.DEFAULT:
                setInformerText("\u0424\u0430\u0439\u043B\u043E\u0432 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043E: ".concat(filesDropped.length));
                break;
            case ConstaDragAndDropStatus.ALERT:
                setInformerText("Что-то пошло не так");
                break;
            case ConstaDragAndDropStatus.WARNING:
                setInformerText(getErrorsList(fileRejections).join("\n"));
                break;
        }
    }, [status, fileRejections]);
    useEffect(function () {
        if (otherError) {
            setStatus(ConstaDragAndDropStatus.ALERT);
        }
        else {
            setStatus(fileRejections.length > 0
                ? ConstaDragAndDropStatus.WARNING
                : ConstaDragAndDropStatus.DEFAULT);
        }
    }, [otherError, fileRejections]);
    useEffect(function () {
        setValue(FeedbackFields.FILES, filesDropped);
    }, [filesDropped]);
    return (_jsx(Layout, __assign({ className: styles.body, direction: "column" }, { children: _jsxs(FormProvider, __assign({}, methods, { children: [_jsxs(Text, __assign({ className: styles.formComponent }, { children: ["\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C: ", parseFullUserName(userName)] })), _jsx(Controller, { name: FeedbackFields.STATUS, control: control, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (_jsx(Select, { className: styles.formComponent, label: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435", items: REASONS_LIST, value: value, onChange: function (item) { return onChange(item); }, getItemKey: function (item) { return item.label; } }));
                    } }), _jsx(Controller, { name: FeedbackFields.CONTENT, control: control, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (_jsx(TextField, { className: styles.formComponent, type: "textarea", rows: DEFAULT_FIELD_ROWS, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435", label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B", onChange: onChange, value: value }));
                    } }), _jsx(Text, __assign({ className: styles.formComponent, view: "secondary" }, { children: "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0444\u0430\u0439\u043B" })), _jsx(DragNDropField, __assign({ accept: ACCEPT_FILES, maxSize: DEFAULT_FILE_SIZE, multiple: true, onDrop: handleDrop }, { children: function (_a) {
                        var openFileDialog = _a.openFileDialog;
                        return getDragAndDropContent();
                    } })), _jsx(DragNDropFieldInformer, { className: styles.informer, status: status, icon: status !== ConstaDragAndDropStatus.DEFAULT ? IconAlert : IconDocFilled, text: informerText, withButton: true, buttonLabel: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C", buttonIcon: IconRevert, onButtonClick: function () {
                        setFilesDropped([]);
                        setFileRejections([]);
                    } }), _jsx(Button, { size: "s", onClick: onSubmit, disabled: Boolean(!watch(FeedbackFields.STATUS)), label: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C" })] })) })));
};
export default Feedback;
